const styles = () => ({
  container: {
    margin: 0,
    padding: 0,
    listStyle: 'none'
  },
  refreshContainer: {
    textAlign: 'center',
    marginTop: '5px'
  },
  refresh: {
    '& svg': {
      marginRight: '4px'
    }
  }
})

export default styles
